import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import apiClient from '../../utils/api';
import { toast } from 'sonner';
import './OnetimeProductPage.css';

function OnetimeProductPage() {
  const { productId } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [purchasing, setPurchasing] = useState(false);

  useEffect(() => {
    loadProduct();
  }, [productId]);

  const loadProduct = async () => {
    try {
      const data = await apiClient.getOnetimeProduct(productId);
      setProduct(data);
    } catch (error) {
      console.error('Error loading product:', error);
      toast.error('Produkt konnte nicht geladen werden');
    } finally {
      setLoading(false);
    }
  };

  const handlePurchase = () => {
    // Navigate to checkout with product details
    const orderDetails = {
      order_type: 'onetime',
      product_id: product.id,
      product_name: product.name,
      amount: product.price,
      billing_interval: 'onetime'
    };
    
    navigate('/checkout', { state: { orderDetails } });
  };

  if (loading) {
    return (
      <div className="onetime-product-loading">
        <div className="spinner"></div>
        <p>Lade Produktinformationen...</p>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="onetime-product-error">
        <h2>Produkt nicht gefunden</h2>
        <button onClick={() => navigate('/dashboard')} className="btn-back">
          Zurück zum Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="onetime-product-page" data-testid="onetime-product-page">
      <div className="product-page-header">
        <button 
          onClick={() => navigate('/dashboard')} 
          className="btn-back"
          data-testid="back-button"
        >
          ← Zurück zum Dashboard
        </button>
      </div>

      <div className="product-showcase">
        <div className="product-icon-large">
          {product.icon}
        </div>
        
        <div className="product-details">
          <h1 className="product-title">{product.name}</h1>
          
          <p className="product-description">
            {product.description}
          </p>

          <div className="product-features">
            <h3>Was ist enthalten:</h3>
            <ul>
              <li>✅ Premium Proxy-Karte</li>
              <li>✅ Erweiterte Funktionen</li>
              <li>✅ Lebenslanger Zugang</li>
              <li>✅ Sofortiger Download nach Kauf</li>
            </ul>
          </div>

          <div className="product-pricing">
            <div className="price-box">
              <span className="price-label">Einmalzahlung</span>
              <span className="price-amount">{product.price.toFixed(2)} €</span>
              <span className="price-note">inkl. MwSt.</span>
            </div>
          </div>

          <div className="product-actions">
            <button
              onClick={handlePurchase}
              disabled={purchasing || !product.active}
              className="btn-purchase"
              data-testid="purchase-button"
            >
              {purchasing ? (
                <>
                  <div className="btn-spinner"></div>
                  Weiterleitung zu PayPal...
                </>
              ) : (
                <>
                  💳 Jetzt kaufen mit PayPal
                </>
              )}
            </button>
            
            {!product.active && (
              <p className="product-unavailable">
                Dieses Produkt ist derzeit nicht verfügbar
              </p>
            )}
          </div>

          <div className="payment-info">
            <p>🔒 Sichere Zahlung über PayPal</p>
            <p>💯 14 Tage Geld-zurück-Garantie</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnetimeProductPage;
